import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { track } from './analytics';
import { isVisible } from './helpers';

function initModal(e) {
	if (e) {
		e.stopPropagation();

		if (e.currentTarget.querySelector('.modal__wrapper').contains(e.target)) {
			return;
		}
	}

	var modal = document.querySelector('.modal');

	if (this && this.querySelector('.modal__wrapper .modal')) {
		modal = this.querySelector('.modal__wrapper .modal');
	}

	modal.setAttribute('open', true);

	disableBodyScroll(modal);
	handleModalTabbing();

	if (!e) return;

	var videoId = this.querySelector('.modal__close-modal') ? this.parentElement.querySelector('.modal__close-modal').getAttribute('data-video-id') : null;

	// If user has already opened the modal, abort
	if (document.querySelector('.' + this.classList[0]).closest('.modal--video')) return;

	// If there is no terms overlay, simply play the video
	if (!this.parentElement.querySelector('.video-player__container--terms') && videoId) {
		jwplayer('video-player-' + videoId).play();
	}

	this.querySelector('.modal__wrapper').classList.remove('hide');

	if (this.classList.contains('teacher__bio-image-container')) {
		track('Teacher - Trailer Played', {
			teacher_id: videoId,
			teacher_name: document.querySelector('.teacher__name').innerText
		});
	} else if (this.classList.contains('class-card')) {
		this.classList.add('class-card--is-open');
	}
}

function closeModal(e) {
	e.stopPropagation();

	var urlParams = new URLSearchParams(window.location.search);
	var videoId = e.target.getAttribute('data-video-id');

	if (videoId) jwplayer('video-player-' + videoId).stop();

	e.target.closest('.modal__wrapper').classList.add('hide');
	e.target.parentElement.removeAttribute('open');

	if (e.target.closest('.class-card')) {
		e.target.closest('.class-card').classList.remove('class-card--is-open');
	}

	clearAllBodyScrollLocks();
	// Fail safe in case `clearAllBodyScrollLocks` doesn't work properly (this was happening on /live?livestream-details=1234)
	document.body.style.overflow = '';

	if (urlParams.get('livestream-details')) {
		window.history.pushState({}, document.title, window.location.pathname);
	}
}

// Modal Tab Trapping
function handleModalTabbing() {
	var tabbableElementsArray = [
		'a[href]:not([disabled])',
		'button:not([disabled])',
		'textarea:not([disabled])',
		'input[type="text"]:not([disabled])',
		'input[type="radio"]:not([disabled])',
		'input[type="checkbox"]:not([disabled])',
		'input[type="email"]:not([disabled])',
		'select:not([disabled])',
		'video',
	];
	var focusableEls = document.querySelector('.modal[open]').querySelectorAll(tabbableElementsArray.join(','));
	var firstFocusableEl = focusableEls[0];
	var lastFocusableEl = focusableEls[focusableEls.length - 1];

	if (!focusableEls.length) return;

	setTimeout(function() {
		if (firstFocusableEl.hidden) {
			focusableEls.forEach(function(element) {
				if (isVisible(element)) {
					firstFocusableEl = element;
					return false;
				}
			});
		}
		firstFocusableEl.focus();
	}, 500);

	document.querySelector('.modal[open]').addEventListener('keydown', function(e) {
		var tabKeyCode = 9;
		var isTabPressed = (e.key === 'Tab' || e.keyCode === tabKeyCode);

		if (!isTabPressed) return;

		if (e.shiftKey) /* shift + tab */ {
			if (document.activeElement === firstFocusableEl) {
				lastFocusableEl.focus();
				e.preventDefault();
			}
		} else /* tab */ {
			if (document.activeElement === lastFocusableEl) {
				firstFocusableEl.focus();
				e.preventDefault();
			}
		}
	});
}

export { initModal, closeModal, handleModalTabbing };
